import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  ElementRef,
  NgZone,
} from '@angular/core';
import { LoginService } from './services/login.service';
import { Observable, ReplaySubject, Subject, Subscription } from 'rxjs/Rx';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from 'app/utils/config-service';

@Component({
  selector: 'app-login-component',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [],
})
export class LoginComponent implements OnInit {
  @ViewChild('googleButton') el: ElementRef;
  public subscription: Subscription;
  public loggingIn: boolean;
  public errorMessage: string;
  private auth2: gapi.auth2.GoogleAuth;

  constructor(
    private loginService: LoginService,
    private configService: ConfigService,
    private zone: NgZone
  ) {
    gapi.load('auth2', () => {
      this.auth2 = gapi.auth2.init({
        client_id: this.configService.getEnv('googleClientId'),
      });
    });
  }

  ngOnInit() {
    this.loggingIn = false;
  }

  signIn(googleUser) {
    setTimeout(() => {
      this.errorMessage = undefined;
      this.loggingIn = true;

      this.getAccessToken(googleUser);
    }, 0);
  }

  public signInToGoogle() {
    this.auth2
      .signIn()
      .then((user) => {
        this.signIn(user);
      })
      .catch((e) => {
        console.log('error');
      });
  }

  public signOut() {
    this.auth2.signOut();
  }

  getAccessToken(googleUser: any): void {
    this.loginService.getAccessToken(googleUser).subscribe(
      (result: any) => {
        this.loginService.setAccessToken(result);
        this.zone.run(() => {
          this.loggingIn = false;
          this.loginService.navigate();
        });
      },
      (result: HttpErrorResponse) => {
        this.zone.run(() => {
          this.loggingIn = false;
          this.errorMessage = 'Log in failed';
          if (result && result.error && result.error.error) {
            this.errorMessage = result.error.error;
          }
        });
      }
    );
  }

  hasErrorMessage(): boolean {
    return !this.loggingIn && this.errorMessage !== undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/login.component.ts